/**
 * @file refs.js
 * @location src/utils/refs.js
 * @role 참고 링크(URL) 검증·정규화 순수 유틸 (할당 시 첨부 — 파일 호스팅 X, 가리키기만).
 *  상한: 최대 5개 · url≤500 · label≤60 · http(s) 만.
 */
const MAX_REFS = 5;
const MAX_URL = 500;
const MAX_LABEL = 60;

/** http/https 절대 URL 인지. */
export function isHttpUrl(s) {
  try {
    const u = new URL(String(s));
    return u.protocol === 'http:' || u.protocol === 'https:';
  } catch {
    return false;
  }
}

/** 표시 라벨 — label 있으면 그대로, 없으면 호스트명(파싱 실패 시 원문). */
export function refLabel(ref) {
  const label = (ref?.label ?? '').trim();
  if (label) return label;
  try {
    return new URL(ref.url).host;
  } catch {
    return ref?.url ?? '';
  }
}

/** 배열 정규화: 비-http 제거, 길이 clamp, 빈 label 키 생략, 최대 5개. */
export function normalizeRefs(raw) {
  if (!Array.isArray(raw)) return [];
  const out = [];
  for (const r of raw) {
    const url = String(r?.url ?? '').trim().slice(0, MAX_URL);
    if (!isHttpUrl(url)) continue;
    const label = String(r?.label ?? '').trim().slice(0, MAX_LABEL);
    out.push(label ? { url, label } : { url });
    if (out.length >= MAX_REFS) break;
  }
  return out;
}
